import React from "react";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";
import SimpleBar from "simplebar-react";

import LoadingSpinner from "./Spinner";
import HandleDateTime from "./HandleDateTime";

// Presentational timeline for the current user's recently viewed records.
// Shared by the standalone Recently Viewed page and the Settings panel so
// both render exactly the same data. Caller supplies items + loading and
// owns the data fetch (dispatch getRecentlyViewedList).
const RecentlyViewedList = ({ items, loading, maxHeight = "75vh" }) => {
  if (loading) {
    return (
      <div className="p-4">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <SimpleBar style={{ maxHeight }} className="p-3">
      <div className="acitivity-timeline acitivity-main">
        {isEmpty(items) ? (
          <div className="acitivity-item d-flex">
            <div className="flex-grow-1 ms-3 mb-2">
              <h6 className="mb-1 lh-base">Nothing yet</h6>
              <p className="text-muted mb-1">
                Records you open will appear here.
              </p>
            </div>
          </div>
        ) : (
          items?.map((item, key) => (
            <div className="acitivity-item d-flex" key={key}>
              <div className="flex-shrink-0 avatar-xs acitivity-avatar">
                <div className="avatar-title bg-soft-success text-success rounded-circle">
                  <i className={`${item.ZIcon}`} />
                </div>
              </div>
              <div className="flex-grow-1 ms-3 mb-2">
                <h6 className="mb-1 lh-base">{item?.Title}</h6>
                {item?.Description && (
                  <p className="text-muted mb-1">{item.Description}</p>
                )}
                <small className="mb-0 text-muted">
                  {HandleDateTime(item?.ReportedDateTime)}
                </small>
                <div className="d-flex justify-content-end">
                  <Link
                    to={`${item?.UrlLink}`}
                    className="text-decoration-underline"
                  >
                    Open
                  </Link>
                </div>
                <hr />
              </div>
            </div>
          ))
        )}
      </div>
    </SimpleBar>
  );
};

export default RecentlyViewedList;
